<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_reset === true">รีเซ็ตรหัสผ่านเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-3">
          <v-divider/>
          <v-tabs grow color="#8cc63e">
            <v-tab @click="page(2)" style="font-size: 18px">พนักงาน</v-tab>
            <v-tab @click="page(1)" style="font-size: 18px">ผู้ดูแลระบบ</v-tab>
          </v-tabs>
          <v-divider/>
          <div v-if="loading_data === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="text-right mt-2">
              <router-link to="/addadmin" v-if="title_add === 2">
                <v-btn height="65" class="white--text grad-success-bg btn_mobile">เพิ่มพนักงาน</v-btn>
              </router-link>
              <v-btn height="65" class="white--text grad-success-bg btn_mobile" @click="add_admin = true" v-if="title_add === 1">เพิ่มผู้ดูแลระบบ</v-btn>
            </div>
            <v-card-title>
              <v-text-field v-model="search" color="#8cc63e" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_admin" :footer-props="footer_Props" :items-per-page="Per_page" :search="search" mobile-breakpoint="0">
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.user_code }}</td>
                  <td>{{ dataDetail.item.username }}</td>
                  <td>{{ dataDetail.item.name }}</td>
                  <td>
                    <div v-if="dataDetail.item.telephone !== null">{{ dataDetail.item.telephone }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.email !== null">{{ dataDetail.item.email }}</div>
                    <div v-else>-</div>
                  </td>
                  <td><v-switch color="#8cc63e" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)" v-model="dataDetail.item.status" :disabled="disabled_status"></v-switch></td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDetails(dataDetail.item.id)" class="grad-success-bg white--text mr-1 mb-1" title="ดูรายละเอียด">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn v-if="title_add === 1" small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
                    <v-btn v-else small height="42" @click="getEditAdd(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="delAlert(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                  <td v-if="$store.state.status === 1">
                    <v-btn small height="42" @click="password_reset(dataDetail.item.id)" class="grad-main-bg white--text mr-1 mb-1" title="รีเซ็ตรหัสผ่าน">
                      รีเซ็ตรหัสผ่าน
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <v-dialog v-model="add_admin" persistent max-width="900">
            <v-card>
              <v-form ref="add_form" @submit.prevent="createAdmin">
                <v-card-title>
                  เพิ่มผู้ดูแลระบบ
                </v-card-title>

                <v-card-text>
                  <div>
                    <div>
                      <div class="d-flex">
                        <v-icon>mdi-account</v-icon>
                        <div class="ml-1">รหัสผู้ดูแลระบบ : {{ admin_add.user_code }}</div>
                      </div>
                    </div>
                    <div class="grid_half">
                      <div class="mt-3 mr-1">
                        <v-tooltip right color="black">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field color="#86bc3a" label="ชื่อสำหรับเข้าสู่ระบบ" @paste="isPaste($event)" @keypress="isCharacter($event)" prepend-inner-icon="mdi-account-outline" :rules="loginRules" hide-details="auto" required v-model="admin_add.username" outlined>
                              <v-icon color="black lighten-1" slot="append" v-bind="attrs" v-on="on">
                                mdi-alert-circle
                              </v-icon>
                            </v-text-field>
                          </template>
                          <span>กรุณากรอกตัวอักษร A-z ก-ฮ 0-9</span>
                        </v-tooltip>
                      </div>
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" hide-details="auto" required v-model="admin_add.name" outlined></v-text-field>
                      </div>
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" label="เบอร์โทรศัพท์" type="tel" maxlength="11" prepend-inner-icon="mdi-phone-outline" @keypress="isNumber($event, admin_add.telephone)" hide-details="auto" v-model="admin_add.telephone"  outlined></v-text-field>
                      </div>
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" label="อีเมล" type="email" @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline" hide-details="auto" v-model="admin_add.email"  outlined></v-text-field>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <div class="text-center pa-4">
                  <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                    บันทึก
                  </v-btn>
                  <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="add_admin = false">
                    ยกเลิก
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog v-model="modal_details" max-width="900">
            <div v-if="loading_modal === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-card>
                <v-form ref="add_form" @submit.prevent="">
                  <v-card-title>
                    รายละเอียด
                  </v-card-title>
                  <v-card-text>
                    <div>
                      <div class="ml-1">รหัสผู้ดูแลระบบ : {{ admin_details.user_code }}</div>
                      <v-card-title class="ml-n4">
                        ข้อมูลส่วนตัว
                      </v-card-title>
                      <div class="grid_half">
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="d-flex">
                            <div><v-icon>mdi-account</v-icon></div>
                            <div class="ml-2 mt-1 mr-2">ชื่อสำหรับเข้าสู่ระบบ</div>
                          </div>
                          <div class="ml-2 mt-1 grey--text">{{ admin_details.username }}</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="d-flex">
                            <div><v-icon>mdi-account-outline</v-icon></div>
                            <div class="ml-2 mt-1 mr-2">ชื่อ - สกุล</div>
                          </div>
                          <div class="ml-2 mt-1 grey--text">{{ admin_details.name }}</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="d-flex">
                            <div><v-icon>mdi-phone-outline</v-icon></div>
                            <div class="ml-2 mt-1 mr-2">เบอร์โทรศัพท์</div>
                          </div>
                          <div class="ml-2 mt-1 grey--text">{{ admin_details.telephone }}</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="d-flex">
                            <div><v-icon>mdi-email-outline</v-icon></div>
                            <div class="ml-2 mt-1 mr-2">อีเมล</div>
                          </div>
                          <div class="ml-2 mt-1 grey--text">{{ admin_details.email }}</div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-danger-bg white--text btn_mobile" type="button" style="font-size: 18px" @click="modal_details = false">
                      ปิด
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </div>
          </v-dialog>
          <v-dialog v-model="modal_edit" persistent max-width="900">
            <div v-if="loading_modal === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-card>
                <v-form ref="update_form" @submit.prevent="updateAdmin">
                  <v-card-title>
                    แก้ไขรายละเอียด
                  </v-card-title>

                  <v-card-text>
                    <div>
                      <div>
                        <div class="d-flex">
                          <v-icon>mdi-account</v-icon>
                          <div class="ml-1">รหัสผู้ดูแลระบบ : {{ admin_details.user_code }}</div>
                        </div>
                      </div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <v-tooltip right color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field color="#86bc3a" label="ชื่อสำหรับเข้าสู่ระบบ" @paste="isPaste($event)" @keypress="isCharacter($event)" prepend-inner-icon="mdi-account-outline" :rules="loginRules" hide-details="auto" required v-model="admin_details.username" outlined>
                                <v-icon color="black lighten-1" slot="append" v-bind="attrs" v-on="on">
                                  mdi-alert-circle
                                </v-icon>
                              </v-text-field>
                            </template>
                            <span>กรุณากรอกตัวอักษร A-z ก-ฮ 0-9</span>
                          </v-tooltip>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" hide-details="auto" v-model="admin_details.name" required outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="เบอร์โทรศัพท์" type="tel" maxlength="11" prepend-inner-icon="mdi-phone-outline" @keypress="isNumber($event, admin_details.telephone)" hide-details="auto" v-model="admin_details.telephone"  outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="อีเมล" type="email" @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline"  hide-details="auto" v-model="admin_details.email"  outlined></v-text-field>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px" >
                      แก้ไข
                    </v-btn>
                    <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="modal_edit = false">
                      ยกเลิก
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </div>
          </v-dialog>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { HTTP } from '@/axios.js'
import {isTelephone, onPaste, validateCharacter, validateEmail} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      loading_data: false,
      loading_modal: false,
      title_add: 2,
      add_admin: false,
      Per_page: -1,
      search: null,
      modal_details: false,
      modal_edit: false,
      modal_delete: false,
      alert_success: false,
      alert_reset: false,
      disabled_status: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      phoneRules: [v => ( v.length === 10 ) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      loginRules: [
        v => !!v || 'กรุณากรอกชื่อสำหรับเข้าสู่ระบบ',
        v => ( v.length > 2 ) || 'กรุณากรอกตัวอักษรมากกว่า 3 ตัวขึ้นไป',
      ],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      admin_details: {
        id: null,
        user_code: null,
        username: null,
        name: null,
        telephone: '',
        email: null,
      },
      admin_add: {
        id: null,
        user_code: null,
        username: null,
        name: null,
        telephone: '',
        email: null,
      },
      headers: [],
      data_admin: [],
    }
  },
  methods: {
    checkLoading() {
      this.loading_page = true
      HTTP.post('/users/lists', {
        user_type: this.title_add
      }).then((res) => {
        if (res.data.success === true){
          this.loading_page = false
          this.data_admin = res.data.object
        }
      })
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    isCharacter: function (evt) {
      return validateCharacter(evt)
    },
    async page(type) {
      this.title_add = type
      if (type === 2 && this.$store.state.status === 1) {
        this.headers = [
          {
            text: 'รหัสพนักงาน',
            value: 'user_code',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ชื่อเข้าสู่ระบบ',
            value: 'username',
            fixed: true,
            width: '250px',
          },
          {
            text: 'ชื่อพนักงาน',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'อีเมล',
            value: 'email',
            fixed: true,
            width: '250px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '125px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'รีเซ็ตรหัสผ่าน',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
      }
      else if (type === 2 && this.$store.state.status === 2) {
        this.headers = [
          {
            text: 'รหัสพนักงาน',
            value: 'user_code',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ชื่อเข้าสู่ระบบ',
            value: 'username',
            fixed: true,
            width: '250px',
          },
          {
            text: 'ชื่อพนักงาน',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'อีเมล',
            value: 'email',
            fixed: true,
            width: '250px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '125px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
      }
      if (type === 1 && this.$store.state.status === 1) {
        this.headers = [
          {
            text: 'รหัสผู้ดูแลระบบ',
            value: 'user_code',
            fixed: true,
            width: '170px',
          },
          {
            text: 'ชื่อเข้าสู่ระบบ',
            value: 'username',
            fixed: true,
            width: '250px',
          },
          {
            text: 'ชื่อผู้ดูแลระบบ',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'อีเมล',
            value: 'email',
            fixed: true,
            width: '250px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '125px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'รีเซ็ตรหัสผ่าน',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
      }
      else if (type === 1 && this.$store.state.status === 2) {
        this.headers = [
          {
            text: 'รหัสผู้ดูแลระบบ',
            value: 'user_code',
            fixed: true,
            width: '170px',
          },
          {
            text: 'ชื่อเข้าสู่ระบบ',
            value: 'username',
            fixed: true,
            width: '250px',
          },
          {
            text: 'ชื่อผู้ดูแลระบบ',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'อีเมล',
            value: 'email',
            fixed: true,
            width: '250px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '125px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
      }
      this.getUser();
    },
    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit('logout_success');
        this.$router.push('/login');
      }
      if (this.$store.state.status !== 1) {
        this.$router.push('/customer')
      }
    },
    createAlert() {
      Swal.fire({
        title: 'บันทึกข้อมูลเรียบร้อย !',
        icon: 'success',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.getUser()
        }
        else {
          this.getUser()
        }
      });
    },
    editAlert() {
      Swal.fire({
        title: 'แก้ไขข้อมูลเรียบร้อย !',
        icon: 'success',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.getUser()
        }
        else {
          this.getUser()
        }
      });
    },
    delAlert(id) {
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.getDelete(id)
        }
      });
    },
    createAdmin() {
      if (this.$refs.add_form.validate()) {
        if (this.admin_add.username !== null && this.admin_add.name !== null && this.admin_add.username !== '' && this.admin_add.name !== '') {
          HTTP.post('/users/admin/create', {
            user_type: 1,
            id: this.admin_add.id,
            user_code: this.admin_add.user_code,
            username: this.admin_add.username,
            name: this.admin_add.name,
            telephone: this.admin_add.telephone,
            email: this.admin_add.email,
          }).then((res) => {
            if (res.data.success === true){
              this.admin_add.name = '';
              this.admin_add.telephone = '';
              this.admin_add.email = '';
              this.add_admin = false;
              this.createAlert();
            }
            else {
              Swal.fire({
                title: 'ไม่สามารถบันทึกได้ !',
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.admin_add.username = null
              })
            }
          })
        }else {
          Swal.fire({
            title: 'ไม่สามารถบันทึกได้ !',
            text: 'กรุณาตรวจสอบข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.$refs.add_form.validate()
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถบันทึกได้ !',
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    password_reset(id) {
      Swal.fire({
        title: 'คุณต้องการรีเซ็ตรหัสผ่านหรือไม่ ?',
        text: 'รหัสผ่านจะถูก รีเซ็ตเป็นค่าเริ่มต้น !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/users/reset',{
            user_id: id,
          }).then((result) => {
            if (result.data.success === true) {
              this.alert_reset = true
              setTimeout(() => this.alert_reset = false,2000)
            }
          })
        }
      })
    },
    genIdCode() {
      HTTP.post('/users/admin/latest')
          .then((res) => {
            if (res.data.success === true){
              this.admin_add.user_code = res.data.object;
            }
          })
    },
    getUser() {
      this.loading_data = true
      HTTP.post('/users/lists', {
        user_type: this.title_add
      }).then((res) => {
        if (res.data.success === true){
          this.loading_data = false
          this.data_admin = res.data.object
        }
      })
    },
    getDetails(id) {
      this.modal_details = true;
      this.loading_modal = true
      HTTP.post('/users/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true){
          this.loading_modal = false
          this.admin_details.id = res.data.object.id;
          this.admin_details.user_code = res.data.object.user_code;
          this.admin_details.username = res.data.object.username;
          this.admin_details.name = res.data.object.name;
          this.admin_details.telephone = res.data.object.telephone;
          this.admin_details.email = res.data.object.email;
        }
      })
    },
    getEdit(id) {
      this.modal_edit = true;
      this.loading_modal = true
      HTTP.post('/users/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true){
          this.loading_modal = false
          this.admin_details.id = res.data.object.id;
          this.admin_details.user_code = res.data.object.user_code;
          this.admin_details.username = res.data.object.username;
          this.admin_details.name = res.data.object.name;
          this.admin_details.telephone = res.data.object.telephone;
          this.admin_details.email = res.data.object.email;
        }
      })
    },
    getEditAdd(id) {
      this.$router.push('/editemp/' + id);
    },
    updateAdmin() {
      if (this.$refs.update_form.validate()) {
        HTTP.post('/users/admin/edit', {
          username: this.admin_details.username,
          id: this.admin_details.id,
          name: this.admin_details.name,
          telephone: this.admin_details.telephone,
          email: this.admin_details.email
        }).then((res) => {
          if (res.data.success === true){
            this.admin_details.username = '';
            this.admin_details.id = null;
            this.admin_details.name = '';
            this.admin_details.telephone = '';
            this.admin_details.email = '';
            this.modal_edit = false;
            this.editAlert();
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถบันทึกได้ !',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถบันทึกได้ !',
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getDelete(id) {
      HTTP.post('/users/delete', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          Swal.fire({
            title: 'ลบข้อมูลเรียบร้อย !',
            icon: 'success',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              this.getUser();
            }
            else {
              this.getUser();
            }
          })
        }
      });
    },
    changeStatus(id, status) {
      if (status == false) {
        status = 0
      }
      else if (status == true) {
        status = 1
      }
      this.disabled_status = true
      HTTP.post('/users/updatestatus', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.disabled_status = false
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 1000)
        }
      })
    },
  },
  beforeMount() {
    this.checkLogIn();
    this.checkLoading();
  },
  mounted() {
    this.genIdCode();
    this.page(2)
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_flex {
  display: flex;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
